export const paymentTypes = {
  NEW: "new",
  RENEW: "renew",
  UPGRADE: "upgrade",
  PENDING: "pending"
};
